import React from "react";
import { CountryCode } from "../../utils/Constants";
import {useTranslation} from "react-i18next";

interface PhoneInputProps {
  phoneNumber: string;
  setPhoneNumber: (value: string) => void;
  countryCode: CountryCode;
  setCountryCode: (value: CountryCode) => void;
  isPhoneValid: boolean;
  errorMessage: string;
}

export const PhoneInput: React.FC<PhoneInputProps> = ({
  phoneNumber,
  setPhoneNumber,
  countryCode,
  setCountryCode,
  isPhoneValid,
  errorMessage,
}) => {
  const { t } = useTranslation();
  return (
    <div className="my-4">
      <label className="block text-sm font-medium mb-2 text-left" htmlFor="phone">
        {t('AuthPhoneNumber')}
      </label>
      <div className="grid grid-cols-3 gap-2">
        {/* Country Code Selector */}
        <select
          className="border border-black rounded-md px-3 py-2 bg-white text-black"
          value={countryCode}
          onChange={(e) => setCountryCode(e.target.value as CountryCode)}
        >
          <>
            {Object.entries(CountryCode).map(([key, value]) => (
              <option key={key} value={value as string}>
                {'+' + value}
              </option>
            ))}
          </>
        </select>

        {/* Phone Number Input */}
        <input
          type="text"
          id="phone"
          placeholder={t('AuthPhoneNumberPlaceholder')}
          className={`col-span-2 rounded-md px-3 py-2 bg-white text-black border-2 ${
            isPhoneValid ? "border-black" : "border-red-500"
          }`}
          value={phoneNumber}
          inputMode='numeric'
          pattern='[0-9]*'
          onChange={(e) => setPhoneNumber(e.target.value)}
        />
      </div>
      {/* Error Message */}
      {!isPhoneValid && <p className="text-red-500 text-sm mt-2">{errorMessage}</p>}
    </div>
  )
}